import React, { useEffect, useState } from 'react';
import { Chart } from 'react-chartjs-2';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import { useGetIndicadores } from '../hooks/useGetIndicadores';
import { year_options } from '../../../../components/develop-nilton-components/hooks/time_options';

export function ObservaçãoAnual({ tab, tabType }: {tab:number, tabType: number}) {
  const { indicador: observacoes, handleSetIndicador: handle_set_observacoes } = useGetIndicadores();

  const options_graphics = [
    {
      title: "Obsevações",
      type: "line",
      options: {
        plugins: {
          legend: { display: false, position: "left" },
        },
      },
      data: observacoes,
      onChange: (e:any) => {
        handle_set_observacoes("queixas", e.target.value);
      },
    },
  ];

  const [load, set_load] = useState(false);

  useEffect(() => {
    (async () => {
      set_load(false);
      await handle_set_observacoes("observacoes", new Date().getFullYear());
      set_load(true);
    })();
  }, [tab, tabType]);

  return (
    <div>
      {!load && (
        <div className="d-flex justify-content-center m-5">
          <SpinnerLoading />
        </div>
      )}
      {load && options_graphics.map(({
        data, type, options, title, onChange,
      }, i) => (
        <div key={i}>
          <div className="mt-3 border-bottom border-secondary d-flex">
            <h3 className="mr-2">{title}</h3>
            <select
              style={{ height: 35, width: 90, cursor: "pointer" }}
              className="form-control"
              onChange={onChange}
            >
              {year_options.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center flex-column w-100">
            <div>
              <Chart
                // @ts-ignore
                type={type}
                data={data}
                // @ts-ignore
                options={options}
                style={{ width: type === "line" ? 900 : 600 }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
